var map = {
	"./Facebook_icon_2013.svg": "411d",
	"./avatar.png": "4d41",
	"./avatar2.png": "66bf",
	"./landing.jpg": "4f88",
	"./logo.svg": "e347",
	"./netflix-logo.png": "145e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";